import Icon from "@/components/icon";

const BENEFITS = [
  {
    icon: "educator-installment-semi",
    title: "فروش قسطی",
    description: "دوره های خودتو ۴ قسطه تو ویترین بفروش",
  },
  {
    icon: "educator-miniapp-semi",
    title: "برنامه اختصاصی",
    description: "برنامه اختصاصی خودتو تو ایتا داشته باش",
  },
  {
    icon: "educator-users-semi",
    title: "کاربر آماده برای خرید",
    description: "دیده شدن توسط میلیون ها کاربر ایتا و اسنپ",
  },
] as const;

export default function EducatorsBenefitsSection() {
  return (
    <section className="p-4 w-full">
      <div className="rounded-3xl bg-background p-2 shadow-sm">
        <img
          src="/educator-assets/s2.webp"
          alt="مزایای فروش دوره در آموزیم"
          className="block w-full rounded-2xl"
        />

        <div className="p-2">
          {BENEFITS.map((benefit, index) => (
            <div key={benefit.title}>
              <a
                href={`#educators-feature-${index}`}
                className="flex py-4 items-center gap-3 transition-opacity active:opacity-70"
                dir="rtl"
              >
                <span className="flex size-12 shrink-0 items-center justify-center rounded-2xl bg-content3 text-primary">
                  <Icon name={benefit.icon} size={24} />
                </span>

                <div className="min-w-0 flex-1 text-right">
                  <h3 className="text-sm font-bold leading-5 text-foreground">
                    {benefit.title}
                  </h3>
                  <p className="text-xs leading-7 text-default-700">
                    {benefit.description}
                  </p>
                </div>

                <span
                  aria-hidden="true"
                  className="flex size-8 shrink-0 items-center justify-center rounded-full bg-[#f1f1f8] text-default-600"
                >
                  <Icon name="arrow-left" size={20} />
                </span>
              </a>

              {index < BENEFITS.length - 1 ? (
                <div className="mx-[68px] h-px bg-content3" />
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
